export const keyboardKeys = {
  ENTER: 'Enter',
  ESC: 'Escape'
};
export const durations = {
  TIMEOUT: 2500
}
export const endpoints = {
  okendo: (productId) => `https://reviews.okendo.io/stores/2c58e19f-e303-4c60-ab88-4ff70aea4f21/review?productId=shopify-${productId}`,
  stockist: (lat, long, limit = 5) => `https://stockist.co/api/v1/u5129/locations/search?latitude=${lat}&longitude=${long}&limit=${limit}`,
  // geoip: 'https://freegeoip.app/json/',
  // geojs: 'https://get.geojs.io/v1/ip/geo.json',
  ipapi: 'https://pro.ip-api.com/json/?key=62D7H3XrHZcOYB5&fields=lat,lon,country,countryCode'
}
